var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.696 13.878a.553.553 0 0 0-.41-.164h-4v-4a.552.552 0 0 0-.58-.571h-3.411a.552.552 0 0 0-.58.571v4H9.713a.55.55 0 0 0-.571.58v3.412a.553.553 0 0 0 .571.58h4v4a.551.551 0 0 0 .58.571h3.411a.552.552 0 0 0 .58-.571v-4h4a.552.552 0 0 0 .572-.58v-3.41a.57.57 0 0 0-.16-.418zm-6.694-9.992c6.678 0 12.115 5.433 12.115 12.113 0 6.684-5.436 12.116-12.115 12.116-6.682 0-12.117-5.432-12.117-12.116 0-6.68 5.435-12.113 12.117-12.113zm0 28.114C24.823 32 32 24.823 32 16c0-8.82-7.177-16-15.998-16C7.179 0 0 7.18 0 16c0 8.823 7.179 16 16.002 16z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.7e7afdf8.svg";
export { ForwardRef as ReactComponent };